<div class="border-300 mt-3 border-solid p-5">
  <!-- Drag and drop zone -->
  <div
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.dragging]="isFileDragging"
    class="flex flex-column gap-1 h-full text-center justify-content-center align-items-center drag-drop-zone"
  >
    <fa-icon [icon]="faCloudArrowUp" class="faCloudArrowUp"></fa-icon>
    <div>
      <span (click)="openFileInput()" class="browse-file">Browse</span>
      <span style="color: #3e464c">, drag and drop a CSV, or </span>
      <span (click)="downloadTemplate()" class="browse-file"
        >Download Template</span
      >
    </div>
  </div>
  <!-- Hidden file input -->
  <input
    #fileInput
    (change)="handleFileSelection($event)"
    accept=".csv"
    style="display: none"
    type="file"
  />

  <div class="h-full mt-3">
    <!-- once a file is selected, show the table -->
    @if (uploadedCsvFile.length) {
    <p-table [value]="uploadedCsvFile">
      <ng-template pTemplate="header">
        <tr>
          <th class="w-1"></th>
          <th class="w-10">File Name</th>
          <th class="w-1"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
        <tr>
          <td>
            <fa-icon class="fa-3x" [icon]="faFileCSV"></fa-icon>
          </td>
          <td>
            <div class="flex-column">
              {{ file.name }} @if (csvUploadError) {
              <div class="upload-error-message">
                <fa-icon [icon]="faDiamondExclamation"></fa-icon>
                {{ csvUploadError }}
              </div>
              }
            </div>
          </td>
          <td>
            <fa-icon
              class="faTrash"
              [icon]="faTrash"
              (click)="uploadedCsvFile = []"
            ></fa-icon>
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
  </div>
</div>
